const homeRoutes = {
    home: "/",
    dashboard: "/dashboard",
  };
  
  export default homeRoutes;
  